export class AlertDestination{
  id?: string;
  companyId?: string;
  name?: string;
  mailAddress?: string;
  longStayAlertEnabled?: boolean;
  failureAlertEnabled?: boolean;
  lowBatteryAlertEnabled?: boolean;

  constructor(params?: Partial<AlertDestination>) {
    Object.assign(this, params);
  }
}